import { render, staticRenderFns } from "./InfeventsConfigEdit.vue?vue&type=template&id=68d3b5e4&scoped=true"
import script from "./InfeventsConfigEdit.vue?vue&type=script&lang=js"
export * from "./InfeventsConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./InfeventsConfigEdit.vue?vue&type=style&index=0&id=68d3b5e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3b5e4",
  null
  
)

export default component.exports